import { CalendarSvg, LogoSvg } from 'src/components/icons/Icon';
import { useResidentAvailabilitiesContext } from '../context/ResidentAvailibilitiesContext';
// import AtlasRealEstateLogo from 'src/assets/images/atlas-real-estate-logo.png';

const Header = () => {
  const { submittedAvailabilities } = useResidentAvailabilitiesContext();
  return (
    <div className="ra-header">
      {import.meta.env.VITE_PLATFORM === 'lula'
        ? (
          <>
            <div className="title-wrapper">
              <CalendarSvg />
              <h6 className="h5">Resident Availability</h6>
            </div>
            <div className="logo-wrapper">
              <span>Powered by</span>
              <LogoSvg />
            </div>
          </>
        ) : (
          <>
            <div className="logo-img">
              <img alt="" src={submittedAvailabilities?.logo_uri} data-testId="logo-img" />
            </div>
            <div className="logo-wrapper">
              <span>Resident Availability</span>
            </div>
          </>
        )}

    </div>
  );
};

export default Header;
